import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";

export default class FeatureRequestCommentModel extends BaseModel {
  body = null;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    body: 'required',
  };

  attributeHints = {
  };

  attributeLabels = {
    body: i18n.t('New Comment'),
  };
}
